import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.83339 13.8325L1.75006 11.7492L11.7501 1.74916L13.8334 3.8325L3.83339 13.8325ZM14.7167 2.94833C14.2292 2.46083 12.6334 0.865 12.6334 0.865C12.145 0.378333 11.355 0.378333 10.8667 0.865L0.866715 10.865C0.487548 11.245 0.500048 12.1658 0.500048 12.1658V14.6575C0.500048 15.1225 0.869214 15.4525 1.32421 15.3958L3.83338 15.0825C4.28171 15.0675 4.71588 14.9233 5.08338 14.6658L14.7167 4.71583C15.2042 4.2275 15.2042 3.43667 14.7167 2.94833Z",
      fill: "#252729"
    }, null, -1)
  ]))]))
}
export default { render: render }